import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import QuickOverview from './components/QuickOverview';
import IndustryCard from './components/IndustryCard';
import WhyChooseUs from './components/WhyChooseUs';
import ComparisonTable from './components/ComparisonTable';
import IndustryTestimonials from './components/IndustryTestimonials';
import CtaSection from './components/CtaSection';
import { industries } from '../../mocks/industries';

export default function IndustriesPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Industries We Serve - Agricultural Sectors",
    "description": "Precision aerial application and land management services for row crops, grain production, vineyards, timber, livestock, and conservation programs"
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <SEO
        title="Industries We Serve - Agricultural Drone Services by Sector | Greenfield Partners"
        description="Precision aerial application and land management services for row crops, grain production, vineyards, timber, livestock, and conservation programs."
        keywords="row crop drone services, vineyard aerial application, timber management, livestock pasture services, conservation agriculture"
        schema={schema}
      />

      <HeroSection />

      <div className="topo-divider"></div>

      <QuickOverview />

      <div className="topo-divider"></div>

      {/* Detailed Industry Sections */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <span className="inline-block text-emerald-700 font-bold text-xs tracking-widest uppercase mb-4">
              Deep Dive
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              How We Serve Each Sector
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto font-light">
              Every operation is different. Here&apos;s how we tailor our approach to the unique challenges of each industry.
            </p>
          </div>

          <div className="space-y-8">
            {industries.map((industry, index) => (
              <IndustryCard
                key={index}
                name={industry.name}
                tagline={industry.tagline}
                description={industry.description}
                image={industry.image}
                stats={industry.stats}
                challenges={industry.challenges}
                solutions={industry.solutions}
                icon={industry.icon}
                reversed={index % 2 !== 0}
              />
            ))}
          </div>
        </div>
      </section>

      <div className="topo-divider"></div>

      <WhyChooseUs />

      <div className="topo-divider"></div>

      <ComparisonTable />

      <div className="topo-divider"></div>

      <IndustryTestimonials />

      <div className="topo-divider"></div>

      {/* Custom Operations Banner */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="bg-stone-50 rounded-lg p-8 md:p-10 border border-gray-100 flex flex-col md:flex-row items-center gap-8">
            <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full shrink-0">
              <i className="ri-settings-3-line text-3xl text-emerald-700"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Don&apos;t See Your Industry?</h3>
              <p className="text-gray-600 leading-relaxed">
                We work with unique operations that have specific needs. If your land or crops require a custom approach, let&apos;s talk. We adapt our services to fit your goals.
              </p>
            </div>
            <a
              href="/#contact"
              className="inline-flex items-center gap-2 bg-emerald-800 hover:bg-emerald-700 text-white font-bold px-8 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap shrink-0"
            >
              <i className="ri-chat-3-line"></i>
              Let&apos;s Talk
            </a>
          </div>
        </div>
      </section>

      <CtaSection />

      <Footer />
    </div>
  );
}
